export default function initProcesPopups() {
  document.querySelectorAll('[data-toggle-process-popup-btn]').forEach(el => el.addEventListener('click', event => {
    const processPopup = el.closest('.cmeleon-block-content').querySelector('.process-content-popup-wrapper');
    processPopup.classList.toggle('hidden');

    console.log(processPopup.getAttribute('aria-expanded'));

    if(processPopup.getAttribute('aria-expanded') === 'false') {
      processPopup.setAttribute('aria-expanded', 'true');
    }else{
      processPopup.setAttribute('aria-expanded', 'false');
    }
  }));
}
